import React from "react";

const Sparkle2 = ({ color = "#f4d35e" }) => (
  <svg
              className="h-auto w-16 sm:w-20 md:w-24 flex-shrink-0 absolute right-0 top-0 md:bottom-0 md:translate-y-12 translate-x-8 md:translate-x-12 -z-10"
              fill="none"
              viewBox="0 0 92 80"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className=""
                d="m35.213 16.953.595-5.261 2.644 4.587a35.056 35.056 0 0 0 26.432 17.33l5.261.594-4.587 2.644A35.056 35.056 0 0 0 48.23 63.28l-.595 5.26-2.644-4.587a35.056 35.056 0 0 0-26.432-17.328l-5.261-.595 4.587-2.644a35.056 35.056 0 0 0 17.329-26.433Z"
                fill={color}
                stroke="#000"
                strokeWidth="2.868"
              />
              <path
                className=""
                d="M75.062 40.108c1.07 5.255 1.072 16.52-7.472 19.54m7.422-19.682c1.836 2.965 7.643 8.14 16.187 5.121-8.544 3.02-8.207 15.23-6.971 20.957-1.97-3.343-8.044-9.274-16.588-6.254M12.054 28.012c1.34-5.22 6.126-15.4 14.554-14.369M12.035 28.162c-.274-3.487-2.93-10.719-11.358-11.75C9.104 17.443 14.013 6.262 15.414.542c.226 3.888 2.784 11.92 11.212 12.95"
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="2.319"
              />
            </svg>
);
export default Sparkle2;
